import { apiClient } from "../../../lib/axios";
import {
  ProgrammeSummaryResponse,
  DeliveryPerformanceResponse,
  PhaseCountResponse,
  RisksResponse,
  MonthlySpendTrendResponse,
  VarianceAnalysisResponse,
} from "./types";

export const programmeDashboardApi = {

  fetchProgrammeSummary: async (params: Record<string, any>): Promise<ProgrammeSummaryResponse> => {
    const response = await apiClient.get("/projects/programme-summary", { params });
    return response.data;
  },

  fetchDeliveryPerformance: async (params: Record<string, any>): Promise<DeliveryPerformanceResponse> => {
    const response = await apiClient.get("/portfolios/delivery-performance", { params });
    return response.data;
  },

  fetchPhaseCounts: async (params: Record<string, any>): Promise<PhaseCountResponse> => {
    const response = await apiClient.get("/phases/counts", { params });
    return response.data;
  },

  fetchMonthlySpendTrend: async (params: Record<string, any>): Promise<MonthlySpendTrendResponse> => {
    const response = await apiClient.get("/portfolios/monthly-spend-trend", { params });
    return response.data;
  },

  fetchVarianceAnalysis: async (params: Record<string, any>): Promise<VarianceAnalysisResponse> => {
    const response = await apiClient.get("/projects/variance", { params });
    return response.data;
  },

  fetchRisks: async (params: Record<string, any>): Promise<RisksResponse> => {
    const response = await apiClient.get("/risks", { params });
    return response.data;
  },

  fetchPortfolioActivityList: async (
    portfolioId?: string,
   params?: { category?: string[]; owner?: string[]; search_term?: string }
  ): Promise<any> => {
    const filterParams: Record<string, any> = { portfolio_id: portfolioId };
    if (params?.category?.length) filterParams.category = params.category;
    if (params?.owner?.length) filterParams.owner = params.owner;
    if (params?.search_term) filterParams.search_term = params.search_term;
    const response = await apiClient.get("/contractor/activity-list", { params: filterParams });
    return response.data;
  },

};